<template>
	<v-row align="center" align-content="center" class="justify-start" wrap style="width: 100%">
		<v-col cols="auto" class="py-lg-0 d-flex flex-column justify-start pe-lg-0" v-if="on_lg && $i18n.locale !== 'es'">
			<bee-btn
				icon="fa fa-arrow-circle-up"
				color="displayingColor"
				@click="down()"
				context="bond"
				:action-name="actions.GET"
			>
				<template v-slot:content="{}">
					<span class="ps-1">{{$t('previous')}}</span>
				</template>
			</bee-btn>
		</v-col>
		<v-col cols="auto" class="py-lg-0 d-flex flex-column pe-lg-0" v-if="on_lg && $i18n.locale !== 'es'">
			<bee-btn
				context="bond"
				:action-name="actions.GET"
				icon="fa fa-arrow-circle-down"
				color="displayingColor"
				@click="up()"
			>
				<template v-slot:content="{}">
					<span class="ps-1">{{$t('next')}}</span>
				</template>
			</bee-btn>
		</v-col>

		<v-col cols="auto" class="d-flex justify-start align-center" :class="on_lg ? '' : 'ps-3'">
			<bee-btn
				v-if="!on_lg || $i18n.locale === 'es'"
				beeicon
				type="up"
				outer-class="me-3 py-3"
				@click="down()"
				context="bond"
				:action-name="actions.GET"
			></bee-btn>
			<bee-btn
				v-if="!on_lg || $i18n.locale === 'es'"
				beeicon
				type="down"
				outer-class="me-3"
				@click="up()"
				context="bond"
				:action-name="actions.GET"
			></bee-btn>
			<bee-text-field
				v-model.number="localValue"
				:label="label"
				hide-details="true"
				@keydown-enter-prevent="$emit('keydown-enter-prevent', localValue)"
				context="bond"
				:action-name="actions.GET"
				style="width: fit-content; max-width: 70px;"
			></bee-text-field>
		</v-col>
	</v-row>
</template>
<script>
import actions from "../../../../permissions/actions-names.js";
export default {
    name: "BeeBondUpDown",
    
    props: ["label", "items", "value"],

    data: () => ({
		actions
	}),

	computed: {
		localValue: {
			get: function() {
				return this.value;
			},
			set: function(value) {
				this.$emit("input", value);
			}
		},
		on_lg() {
			return this.$vuetify.breakpoint.lg;
		}
    },
    
	methods: {
		up() {
			if (this.items) {
				const step = 1;
				let current_index = this.items.indexOf(this.localValue);
				let next_index = current_index + step;
				if (next_index <= this.items.length - 1) {
					this.localValue = this.items[next_index];
					this.$emit("programmatically-changed");
				}
			}
		},
		down() {
			if (this.items) {
				const step = 1;
				let current_index = this.items.indexOf(this.localValue);
				let previous_index = current_index - step;
				if (previous_index >= 0) {
					this.localValue = this.items[previous_index];
					this.$emit("programmatically-changed");
				}
			}
		}
    },
    
    mounted() {
		if (this.items && !this.value)
			this.localValue = this.items[this.items.length - 1];
	},

	i18n:{
		messages :{
			ar: { 'previous': 'سابق', 'next': 'تالي' },
			en: { 'previous': 'Previous', 'next': 'Next' },
			es: { 'previous': 'Anterior', 'next': 'Próximo' },
		}
	}
};
</script>
<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
	margin-bottom: 0px !important;
}
</style>